import { components } from 'react-select';

import CloseIcon from '@svg/close.svg';

import {
  MenuListProps,
  GroupBase,
} from '../../types';

import s from './MenuListMobileBottom.sss';

const Component = components.MenuList;

export function MenuListMobileBottom<
Option,
IsMulti extends boolean = false,
Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MenuListProps<Option, IsMulti, Group>) {
  return (
    <Component {...props}>
      <>
        <div className={s.mobileMenuHeader}>
          {props.selectProps.placeholder}
          <div
            className={s.closeIconOuter}
            onClick={() => (document.activeElement as HTMLElement).blur()}
            onTouchEnd={
              (e) => {
                e.preventDefault();
                (document.activeElement as HTMLElement).blur();
              }
            }
            role="button"
            tabIndex={0}
            onKeyPress={() => (document.activeElement as HTMLElement).blur()}
          >
            <CloseIcon
              className={s.closeIcon}
              width='19'
              height='19'
            />
          </div>
        </div>
        {props.children}
      </>
    </Component>
  );
}
